
export const getTextbausteinArray = (string, textbausteine) => {
  if (!string) return [];
  console.log({ string, textbausteine });
  const arr1 = string.split(" ");
  const arr2 = arr1.map((i) => parseInt(i));
  const arr3 = arr2.map((i) => {
    const txt = textbausteine.find((tb) => tb.id === i)?.text || "";
    console.log({ i, txt });
    return txt;
  });
  console.log({ string, textbausteine, arr1, arr2, arr3 });
  return arr3;
};
